import { HORIZONTAL_CROP_RESIZER_Z_INDEX } from './UIConstants';
import { useContext, useCallback, useState, useEffect, useMemo } from 'react';
import UndoIcon from '@material-ui/icons/Undo';
import { DragInterfaceContext } from './MouseDragProvider';
import { CropAdjustmentDispatch } from './Contexts';
import { getPointsFromLs } from './Geometry';

const oppositeSide = { left:'Right', right:'Left' }

const sideStyle = (side,height) => ({

	cursor:'relative',
	position:'absolute',
	display:'flex',
	alignItems:'center',
	justifyContent:'center',
	[("borderTop"+oppositeSide[side]+"Radius")]:height,
	[("borderBottom"+oppositeSide[side]+"Radius")]:height,
	[side]:0,
	top:'50%',
	width:height/2,
	height,
	background:'orange',
	opacity:0.7,
	transform:'translate(0,-50%)',
	zIndex:HORIZONTAL_CROP_RESIZER_Z_INDEX,

})


const stopProp = e => e.stopPropagation();

export default function HorizontalCropAdjuster({setLiveSide,...props}){


	let { cellLocation, side, height } = props;

	const { setCropResizeInfo, onMouseMove, onDragEnd } = useContext(CropAdjustmentDispatch);

	const dic = useContext(DragInterfaceContext);
	let { startDrag } = dic;

	const style = useMemo(() => sideStyle(side,height),[height,side]);

	const onDragStart = e => {
		setLiveSide(side);
		setCropResizeInfo(props);
		e.stopPropagation();
		let resolvedProps = { ...props };
		if( e.shiftKey ){
			resolvedProps.side = "rotation_"+props.side;
		}
			
		startDrag({
			event:e,
			onMouseMove,
			...resolvedProps,
			onDragEnd,
			toNullify:[
				setCropResizeInfo,
				setLiveSide,
			],
		})
	}

	return (
		<div 

			cellLocation={cellLocation.join('-')}
			side={side}
			action={"adjust-crop"}
			class="opaque-on-hover yellow-on-hover"
			onMouseDown={onDragStart}
			onClick={stopProp}
			style={style}>
			<div style={{
				position:'absolute',
				fontSize:16,
				width:'100%',
				color:'black',
				width:4,
				height:4,
				background:'black',
				borderRadius:4,
			}}>
			</div>
		</div>

	)
}
